import { create } from 'zustand';
import type { User } from '@/types/domain';
import { clearAuthTokens } from '@/api/client';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: false,
  error: null,
  setUser: (user) => set({ user, error: null }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  logout: () => {
    clearAuthTokens();
    set({ user: null, error: null });
  },
}));

export const selectRole = (s: AuthState): 'guest' | 'client' | 'specialist' | 'admin' => {
  if (!s.user) return 'guest';
  return s.user.role;
};
